export default __webpack_public_path__ + "static/media/icn-preview-24px.164a1c7c.svg";